import React from 'react';
import { connect } from "react-redux";
import { preloaderShow, preloaderHide, alert } from '../../../actions';
import TranslationService from "../../../app/services/TranslationService";
import axios from "axios";
import {config} from "../../../app/config";
import {Button} from "../../icymat-design/Button";
import {Confirmation} from "../../Confirmation";
import {HistoryDirectory} from "./HistoryDirectory";


class HistoryPanelClass extends React.Component {
    /**
     * @param props
     */
    constructor(props) {
        super(props);

        this.state = {
            class: '',
            page: 1,
            pages: 0,
            directories: {},
            talks: [],
            removeAddress: null,
            edit_id: null,
            edit_title: null
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.class === 'imd-opened' && prevState.class !== this.state.class) {
            const that = this;
            that.props.preloaderShow();
            axios.get(config.apiAddress + '/talks?page=1')
                .then(function (response) {
                    that.setState({page: 1, talks: response.data.talks, pages: response.data.meta.pages});

                    if (Object.keys(response.data).indexOf('directories') >= 0) {
                        that.setState({directories: response.data.directories});
                    }

                    that.props.preloaderHide();
                }).catch(function(error) {
                    that.props.alert(TranslationService.trans(that.props.language, 'common.error'));
                    that.props.preloaderHide();
                });
        }
    }

    switchVisibility = () => {
        if (this.state.class !== 'imd-opened') {
            this.setState({class: 'imd-opened'});
        } else {
            this.setState({class: 'imd-closed'});
        }
    }

    open = (talkId) => {
        const that = this;
        axios.get(config.apiAddress + '/talk/' + talkId + '/messages')
            .then(function (response) {
                that.props.load(talkId, response.data);
                that.switchVisibility();
            }).catch(function(error) {
                that.props.alert(TranslationService.trans(that.props.language, 'common.error'));
            });
    }

    loadMore = () => {
        const that = this;

        let page = this.state.page + 1;
        let talks = this.state.talks;

        that.props.preloaderShow();
        axios.get(config.apiAddress + '/talks?page=' + page)
            .then(function (response) {
                that.setState({talks: [...talks, ...response.data.talks], page: page});

                if (Object.keys(response.data).indexOf('directories') >= 0) {
                    that.setState({directories: response.data.directories});
                }

                that.props.preloaderHide();
            }).catch(function(error) {
                that.props.alert(TranslationService.trans(that.props.language, 'common.error'));
                that.props.preloaderHide();
            });
    }

    renderDirectories = () => {
        let rows = [];

        let that = this;
        Object.keys(this.state.directories).forEach(function(directory) {
            rows.push(<HistoryDirectory
                key={rows.length}
                currentTalk={that.props.talk}
                title={directory}
                talks={that.state.directories[directory]}
                open={that.open}
                edit={(talkId, talkTitle) => that.setState({edit_id: talkId, edit_title: talkTitle})}
            />);
        });

        return rows;
    }

    renderTalks = () => {
        let rows = [];

        let that = this;
        this.state.talks.forEach(function(talk) {
            rows.push(
                <li
                    key={talk.id}
                    className={'imd-text-contrast talk' + (that.props.talk !== null && that.props.talk === talk.id ? ' active' : '')}
                    onClick={() => that.open(talk.id)}
                >
                    <span
                        className={'imd-icon imd-icon-trash imd-text-red action-icon'}
                        onClick={(e) => {e.stopPropagation(); that.deleteTalk(talk.id)}}
                    />
                    <span
                        className={'imd-icon imd-icon-edit-pencil action-icon'}
                        onClick={(e) => {e.stopPropagation(); that.setState({edit_id: talk.id, edit_title: talk.title})}}
                    />

                    {talk.title}
                </li>
            );
        });

        return rows;
    }

    deleteTalk = (talkId) => {
        this.setState({removeAddress: config.apiAddress + '/talk/' + talkId});
    }

    saveTitle = () => {
        const that = this;

        that.props.preloaderShow();
        axios.put(config.apiAddress + '/talk/' + that.state.edit_id, {title: that.state.edit_title})
            .then(function (response) {
                that.setState({page: 0, talks: [], edit_id: null, edit_title: null});
                that.loadMore();
            }).catch(function(error) {
                that.props.alert(TranslationService.trans(that.props.language, 'common.error'));
                that.props.preloaderHide();
            });
    }

    /**
     * @returns {XML}
     */
    render() {
        return (
            <div className={"imd-bg-transparent-default history"} style={{display: (this.props.email !== null ? 'block' : 'none')}}>
                <button
                    type="button"
                    className={"history-button"}
                    onClick={() => this.switchVisibility()}
                >
                    <span className={"imd-icon imd-icon-backward-15-seconds imd-text-contrast"} />
                </button>

                <div className={'imd-sidebar ' + this.state.class}>
                    <div className={"imd-sidebar-content imd-bg-blur-real-black"}>
                        <div style={{paddingTop: '40px'}}>
                            {this.renderDirectories()}
                        </div>

                        <hr style={{display: Object.keys(this.state.directories).length === 0 ? 'none' : 'block'}} />

                        <ul>
                            {this.renderTalks()}
                            <li style={{display: this.state.page < this.state.pages ? 'block' : 'none'}}>
                                <Button
                                    color={'accent'}
                                    secondary={true}
                                    text={TranslationService.trans(this.props.language, 'common.load_more')}
                                    onClick={() => this.loadMore()}
                                    style={{width: '100%', marginTop: '13px'}}
                                />
                            </li>
                        </ul>
                    </div>

                    <div className="imd-sidebar-canvas imd-bg-transparent-black" onClick={() => this.setState({class: 'imd-closed'})} />
                </div>

                <Confirmation
                    address={this.state.removeAddress}
                    onSuccess={() => {this.setState({page: 1, removeAddress: null, loaded: false, class: ''}); this.props.reset()}}
                    onCancel={() => this.setState({removeAddress: null})}
                    onError={() => {}}
                />

                <dialog className={'imd-dialog imd-dialog-sm imd-bg-blur-black' + (this.state.edit_id === null ? '' : ' imd-opened')}>
                    <div className="imd-dialog-body imd-bg-20-default imd-text-accent">
                        <div className="imd-dialog-content">
                            <label>
                                {TranslationService.trans(this.props.language, 'common.title')}
                                <input type="text" className="imd-form-control imd-text-main" value={this.state.edit_title} onChange={e => {this.setState({edit_title: e.target.value});}} />
                            </label>
                        </div>

                        <footer>
                            <Button
                                color={'accent'}
                                secondary={true}
                                text={TranslationService.trans(this.props.language, 'common.cancel')}
                                onClick={() => this.setState({edit_id: null, edit_title: null})}
                            />
                            <Button
                                color={'main'}
                                text={TranslationService.trans(this.props.language, 'common.save')}
                                onClick={() => this.saveTitle()}
                            />
                        </footer>
                    </div>
                </dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        language: TranslationService.getLanguage(state.user),
        email: (state.user === null ? null : state.user.email),
        view: state.view,
        services: (state.user === null ? [] : state.user.imid)
    }
};

export const HistoryPanel = connect(mapStateToProps, { preloaderShow, preloaderHide, alert })(HistoryPanelClass);
